import { render, staticRenderFns } from "./tutor-detail-page.html?vue&type=template&id=68ce9a2e&"
import script from "./tutor-detail-page.ts?vue&type=script&lang=ts&"
export * from "./tutor-detail-page.ts?vue&type=script&lang=ts&"
import style0 from "./tutor-detail-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports